function initFilterLinks() {
    const path = window.location.pathname;
    const parts = path.split('/').filter(Boolean);
    
    // Parse current state
    let baseUrl = '/';
    let isTagPage = false;
    let tagSlug = '';
    let currentFilter = 'all'; // all, image, video
    let currentSort = 'latest'; // latest, oldest
    
    // Check if we're on a tag page
    if (parts[0] === 'tag' && parts[1]) {
        isTagPage = true;
        tagSlug = parts[1];
        baseUrl = `/tag/${tagSlug}/`;
        
        // Check for filters in remaining parts
        if (parts.includes('image')) currentFilter = 'image';
        else if (parts.includes('video')) currentFilter = 'video';
        
        if (parts.includes('oldest')) currentSort = 'oldest';
    } else {
        // Homepage filters
        if (parts.includes('image')) currentFilter = 'image';
        else if (parts.includes('video')) currentFilter = 'video';
        
        if (parts.includes('oldest')) currentSort = 'oldest';
    }
    
    // Build URLs for filter links
    const dropdown = document.querySelector('[data-dropdown-menu]');
    if (!dropdown) return;
    
    const filterLinks = dropdown.querySelectorAll('a');
    
    // Post Type links (first 3)
    if (filterLinks[0]) { // All Types
        filterLinks[0].href = baseUrl + (currentSort === 'oldest' ? 'oldest/' : '');
    }
    if (filterLinks[1]) { // Images
        filterLinks[1].href = baseUrl + 'image/' + (currentSort === 'oldest' ? 'oldest/' : '');
    }
    if (filterLinks[2]) { // Videos
        filterLinks[2].href = baseUrl + 'video/' + (currentSort === 'oldest' ? 'oldest/' : '');
    }
    
    // Sort By links (last 2)
    if (filterLinks[3]) { // Latest
        const filterPart = currentFilter !== 'all' ? currentFilter + '/' : '';
        filterLinks[3].href = baseUrl + filterPart;
        if (currentSort === 'latest') {
            filterLinks[3].classList.add('selected');
        }
    }
    if (filterLinks[4]) { // Oldest
        const filterPart = currentFilter !== 'all' ? currentFilter + '/' : '';
        filterLinks[4].href = baseUrl + filterPart + 'oldest/';
        if (currentSort === 'oldest') {
            filterLinks[4].classList.add('selected');
        }
    }
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    // Less than 1 hour: show minutes
    if (diffMins < 60) {
        return diffMins + 'm';
    }
    // Less than 24 hours: show hours
    else if (diffHours < 24) {
        return diffHours + 'h';
    }
    // Less than 7 days: show days
    else if (diffDays < 7) {
        return diffDays + 'd';
    }
    // Otherwise: show "Mon DD" format
    else {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[date.getMonth()] + ' ' + date.getDate();
    }
}

async function renderPosts(){
    document.querySelectorAll('script[data-id="post_data"]').forEach(async function(postDataEl, index){
        const postData = JSON.parse(postDataEl.textContent);
        if(postData.users)
            postData.users = JSON.parse(postData.users);
        const parentElement = postDataEl.closest('[data-index]');
        parentElement.querySelectorAll('.post-link').forEach(link => {
            link.href = 'https://x.com/goodthink1984/status/'+postData.id;
        });
        parentElement.querySelector('.date').href = 'https://x.com/goodthink1984/status/'+postData.id;

        postDataEl.parentElement.innerText = postData.text.replace(/https?:\/\/t\.co\/[\w]+/g, "");
        if(postData.date)
            parentElement.querySelector('.date').innerText = formatDate(postData.date);
        if(postData?.media_url?.length > 0){
            parentElement.querySelector('.post-image').classList.remove('hidden');
            parentElement.querySelector('.post-image img').src = postData.media_url;
        }
        else {
            parentElement.querySelector('.post-image').remove();
        }

        if(postData?.refrenced_tweet_text?.length > 0){
            const quotedTweetEl = parentElement.querySelector('.quoted_tweet');
            quotedTweetEl.onclick = function() { window.open('https://x.com/goodthink1984/status/'+postData.refrenced_tweet_id, '_blank'); };
            quotedTweetEl.classList.remove('hidden!');
            quotedTweetEl.querySelector('img').src = postData.refrence_tweet_user.avatar;
            quotedTweetEl.querySelector('.text-content').innerText = postData.refrenced_tweet_text.replace(/^(@\w+\s*)+/, "");
            quotedTweetEl.querySelector('.name').innerText = postData.refrence_tweet_user.name;
            quotedTweetEl.querySelector('.username').innerText = "@"+postData.refrence_tweet_user.username;
            

            const dateString = postData.refrence_tweet_date;
            if (dateString && dateString.includes('T')) {
                quotedTweetEl.querySelector('.date').innerText = formatDate(dateString);
            }

            quotedTweetEl.classList.remove('hidden!');
        }
        else {
            parentElement.querySelector('.quoted_tweet').remove();
        }

        parentElement.querySelector('.comments_count').innerText = postData.replies || 0;
        parentElement.querySelector('.impression_count').innerText = postData.impressions || 0;
        parentElement.querySelector('.retweet_count').innerText = postData.retweets || 0;
        parentElement.querySelector('.like_count').innerText = postData.likes || 0;

        const shareButton = parentElement.querySelector('.share-button');
        if (shareButton) {
            shareButton.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                const shareUrl = 'https://x.com/goodthink1984/status/' + postData.id;

                if (navigator.share) {
                    try {
                        await navigator.share({
                            title: 'Orwell (satire?)',
                            text: postData.text,
                            url: shareUrl
                        });
                    } catch (err) {
                        console.error('Error sharing:', err);
                    }
                } else {
                    try {
                        await navigator.clipboard.writeText(shareUrl);
                        alert('Link copied to clipboard');
                    } catch (err) {
                        console.error('Error copying to clipboard:', err);
                    }
                }
            });
        }
    })

}
async function captureBookmarkButtons (bookmarkedPosts){
    const bookmarks = document.querySelectorAll('.bookmark');

    try {
        const bookmarkedIds = bookmarkedPosts.map(String);

        // Update bookmark icons based on fetched data
        bookmarks.forEach(function (button) {
            const postID = button.getAttribute('data-id');
            
            // Set initial icon state
            updateBookmarkIcon(button, bookmarkedIds.includes(postID));

            // Add click handler
            button.addEventListener('click', async function (event) {
                event.preventDefault();
                event.stopPropagation();
                if(this.classList.contains('loading')){
                    return;
                }
                const isBookmarked = this.dataset.bookmarked === 'true';
                this.classList.add('loading');
                
                const type = isBookmarked ? 'remove' : 'add';
                
                try {
                    await fetch(upsertBookmarkUrl+'?user_id='+uuid+'&post_id='+postID+'&type='+type);
                    updateBookmarkIcon(button, !isBookmarked);
                } catch (err) {
                    console.error('Error updating bookmark:', err);
                }
                this.classList.remove('loading');
            });
        });
    } catch (err) {
        console.error('Error fetching bookmarks:', err);
    }

    
}
function updateBookmarkIcon(button, isBookmarked) {
    if (isBookmarked) {
        button.classList.add('bookmarked');
        button.dataset.bookmarked = 'true';
    }
    else {
        button.classList.remove('bookmarked');
        button.dataset.bookmarked = 'false';
    }
}
(function () {
    
    if(typeof uuid === 'undefined'){
        document.querySelectorAll('.nav .nav-subscribe a').forEach(function(el) {
            el.innerText = "ORWELL MEMBERS";
        })
    }
    else {
        document.querySelectorAll('.nav .nav-subscribe a').forEach(function(el) {
            el.innerText = "MY ACCOUNT";
        })
    }
    document.querySelectorAll('.sign-up-button').forEach(row => {
        
        row.addEventListener('click', function (event) {
            if(typeof uuid !== 'undefined'){
                const b = confirm('Are you sure you want to sign out?');
                if(b){
                    row.previousElementSibling.click()
                }
            }
            else {
                location.href = '/subscribe';
            }
        })
    })

     var b = async function () {
           if(typeof uuid === 'undefined') {
                return;
            }
           try {
                const bookmarksRes = await fetch(getBookmarsListUrl+'?user_id='+uuid);
                const bookmarkedPosts = await bookmarksRes.json();
                captureBookmarkButtons(bookmarkedPosts)
            } catch (err) {
                console.error('Error fetching bookmarks:', err);
            }
    };
    b();

    renderPosts();
})();

// Simple dropdown menu with outside click close support
function initDropdowns() {
    const dropdowns = document.querySelectorAll('[data-dropdown]');
    
    dropdowns.forEach(dropdown => {
        const trigger = dropdown.querySelector('[data-dropdown-trigger]');
        const menu = dropdown.querySelector('[data-dropdown-menu]');
        const closeBtn = dropdown.querySelector('[data-dropdown-close]');

        closeBtn?.addEventListener('click', (e) => {
            e.stopPropagation();
            menu.classList.add('hidden');
            trigger.classList.remove('active');
        });
        
        if (!trigger || !menu) return;
        
        // Toggle dropdown on trigger click
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            trigger.classList.toggle('active');
            const isOpen = !menu.classList.contains('hidden');
            
            // Close all other dropdowns
            document.querySelectorAll('[data-dropdown-menu]').forEach(m => {
                m.classList.add('hidden');
            });
            
            // Toggle current dropdown
            if (!isOpen) {
                menu.classList.remove('hidden');
            }
        });
        
        // Prevent clicks inside menu from closing it
        menu.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', () => {
        document.querySelectorAll('[data-dropdown-menu]').forEach(menu => {
            menu.classList.add('hidden');
        });
        document.querySelectorAll('[data-dropdown-trigger]').forEach(button => {
            button.classList.remove('active');
        });
    });
}

// Post filtering system
function initPostFilters() {
    const filters = {
        type: 'all', // all, image, video
        sort: 'latest' // latest, oldest
    };
    
    const posts = Array.from(document.querySelectorAll('.post-card'));
    const originalOrder = posts.map(post => ({ element: post, date: post.dataset.date }));
    
    function applyFilters() {
        const container = posts[0]?.parentElement;
        if (!container) return;
        
        let filteredPosts = [...posts];
        
        // Apply type filter based on tags
        if (filters.type !== 'all') {
            filteredPosts = filteredPosts.filter(post => {
                const tags = (post.dataset.tags || '').toLowerCase();
                
                if (filters.type === 'image') return tags.includes('image');
                if (filters.type === 'video') return tags.includes('video');
                return true;
            });
        }
        
        // Apply sort filter
        if (filters.sort === 'oldest') {
            filteredPosts.sort((a, b) => {
                const dateA = new Date(a.dataset.date || 0);
                const dateB = new Date(b.dataset.date || 0);
                return dateA - dateB;
            });
        } else {
            filteredPosts.sort((a, b) => {
                const dateA = new Date(a.dataset.date || 0);
                const dateB = new Date(b.dataset.date || 0);
                return dateB - dateA;
            });
        }
        
        // Hide all posts first
        posts.forEach(post => post.style.display = 'none');
        
        // Show and reorder filtered posts
        filteredPosts.forEach(post => {
            post.style.display = '';
            container.appendChild(post);
        });
    }
    
    // Handle filter clicks
    document.querySelectorAll('[data-filter]').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const filterType = link.dataset.filter;
            const filterValue = link.dataset.value;
            
            filters[filterType] = filterValue;
            
            // Update button label
            const dropdown = link.closest('[data-dropdown]');
            const label = dropdown.querySelector('.filter-label');
            if (label) {
                label.textContent = link.textContent;
            }
            
            applyFilters();
        });
    });
}

// Initialize dropdowns when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initDropdowns();
        initFilterLinks();
    });
} else {
    initDropdowns();
    initFilterLinks();
}